import type { ControlProps } from './types';

export function SpacingControl({ schema, value, disabled, onChange }: ControlProps) {
  const numeric = typeof value === 'number' && Number.isFinite(value) ? value : 0;
  const min = schema.validation?.min ?? 0;
  const max = schema.validation?.max ?? 96;
  return (
    <span className="cf-control-group">
      <input
        type="range"
        aria-label={schema.label}
        min={min}
        max={max}
        step={1}
        value={Math.min(max, Math.max(min, numeric))}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      <span className="cf-number-value">{numeric}px</span>
    </span>
  );
}
